/** 枚举-重置密码按钮类型 */
export const buttonType = {
  /** 去登录 */
  LOGINACCOUNT: 'login',
  /** 提交 */
  SUBMIT: 'submit',
};

/** 枚举-页面状态类型类型 */
export const formEnum = {
  LOGIN: 'LOGIN',
  /** 重置密码 */
  RE_PASSWORD: 'RE_PASSWORD',
  /** 发送邮成功 */
  SEND_SUCCESS: 'SEND_SUCCESS',
  /** 重置成功 */
  RE_SUCCESS: 'RE_SUCCESS',

};
